import { LoadingState } from '@lcs/shared/api';
import { on } from '@ngrx/store';
import { createScheduleSuccess } from 'src/app/pages/add-schedule/state/add-schedule.actions';
import {
   deleteScheduleSuccess,
   saveScheduleDetailSuccess,
} from 'src/app/pages/schedule-details/state/schedule-detail.actions';
import { ScheduleOption } from 'src/app/pages/schedule-register/models/schedule-option-interface';
import {
   EagerSelectState,
   createEagerSelectAdapter,
   createEagerSelectReducer,
} from '../../select/eager-select/eager-select-reducer';
import { filterNamedOption } from '../../select/shared/filter-named-option';
import { scheduleOptionActions } from './schedule-option.actions';

export const scheduleOptionFeatureKey = 'scheduleOptions';

export type ScheduleOptionState = EagerSelectState<ScheduleOption>;

const adapter = createEagerSelectAdapter<ScheduleOptionState, ScheduleOption>({
   featureKey: scheduleOptionFeatureKey,
   selectId: (schedule: ScheduleOption) => {
      return schedule.scheduleId;
   },
});

export const scheduleOptionSelectors = adapter.getSelectors(filterNamedOption);

const initialState = adapter.getInitialState();

export const scheduleOptionsReducer = createEagerSelectReducer(
   adapter,
   initialState,
   scheduleOptionActions.search,
   scheduleOptionActions.searchReset,
   scheduleOptionActions.loadFromApi,
   scheduleOptionActions.loadFromApiSuccess,
   scheduleOptionActions.loadFromApiFailure,
   null,
   on(createScheduleSuccess, saveScheduleDetailSuccess, deleteScheduleSuccess, (state) => {
      return {
         ...state,
         callState: LoadingState.Init,
      };
   })
);
